import { Grid, pn, useElementBreakpoints } from "@compass/core";
import { Select } from "components";
import {
    TestTypeFilter as TestTypeFilterModel,
    ClassFilterResource,
} from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const TestTypeFilter = (props: {
    filter: TestTypeFilterModel;
    setFilter: (value: TestTypeFilterModel) => void;
}) => {
    const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
    const [resource, setResource] = useState<ClassFilterResource>({});
    const properties = resource.properties || [];

    useEffect(() => {
        ApiService.classes.getFilterResource().then((response) => {
            setResource(response);
        });
    }, []);

    const testTypeGroupField = () => {
        const propertyName = pn<TestTypeFilterModel>("testTypeGroupId");
        const property = properties.find((x) => x.propertyName === propertyName);

        return (
            <Select
                modelProperty={property}
                label="School"  
                value={resource.schools?.find((x) => x.id === props.filter.testTypeGroupId)}
                options={resource.schools}
                getOptionLabel={(option) => option.name}
                onChange={(e, value) =>
                    props.setFilter(
                        produce(props.filter, (draft) => {
                            draft.testTypeGroupId = value?.id;
                        })
                    )
                }
            />
        );
    };

    return (
        <Grid ref={breakpointsRef} container spacing="sm">
            <Grid item xs={smallFieldBreakpoints}>
                {testTypeGroupField()}
            </Grid>
        </Grid>
    );
};
